/**
 * Activity API
 * 
 * API client for fetching household activity logs
 */

import axiosClient from './axiosClient';

/**
 * Fetch activity logs for a household
 * 
 * @param {string} householdId - Household ID
 * @param {Object} options - Query options
 * @param {string} options.category - Filter by category (optional)
 * @param {number} options.limit - Max number of activities
 * @param {number} options.skip - Skip N activities (pagination)
 * @returns {Promise<Object>} Activity data
 */
export async function fetchActivityLogs(householdId, { category, limit = 50, skip = 0 } = {}) {
  const params = {};
  
  if (category && category !== 'all') {
    params.category = category;
  }
  
  if (limit) {
    params.limit = limit;
  }
  
  if (skip) {
    params.skip = skip;
  }
  
  const response = await axiosClient.get(`/api/activity/${householdId}`, { params });
  return response.data;
}
